var exports = {
  "Y3": "anchor__PSAOdR",
  "R_": "heading__fzQskI",
  "oE": "compact__3vbapR",
  "kL": "container__mDVuhO",
  "_o": "centerAligned__hkidNm",
  "t8": "trailingBadgesSpacer__YtV8rh",
  "ee": "trailingBadgesContainer__4AEjpg",
  "mG": "inline__z8HXmA",
};

module.exports = exports;
